module.exports = __webpack_public_path__ + "img/public/SiteIcons/locationIdea.svg?6899e4be";